export const KEYS = {
  STORAGE_CUSTOM_SHORTCUT: 'STORAGE_CUSTOM_SHORTCUT',
} as const;

export const PREFIX_STRIP_REGEXP = /(Key|Digit|Numpad)/gi;

export const KEY_ALIAS_MAP = {
  Space: 'space',
  Enter: 'enter',
  Escape: 'esc',
  Backspace: 'backspace',
  Tab: 'tab',
  Delete: 'delete',

  // 화살표 키
  ArrowUp: 'arrowup',
  ArrowDown: 'arrowdown',
  ArrowLeft: 'arrowleft',
  ArrowRight: 'arrowright',

  // 기타 기능 키
  Minus: '-',
  Equal: '=',
  BracketLeft: '[',
  BracketRight: ']',
  Backslash: '\\',
  Semicolon: ';',
  Quote: "'",
  Comma: ',',
  Period: '.',
  Slash: '/',
  Backquote: '`',

  // FN 키
  F1: 'f1',
  F2: 'f2',
  F3: 'f3',
  F4: 'f4',
  F5: 'f5',
  F6: 'f6',
  F7: 'f7',
  F8: 'f8',
  F9: 'f9',
  F10: 'f10',
  F11: 'f11',
  F12: 'f12',

  // Navigation 키
  Home: 'home',
  End: 'end',
  PageUp: 'pageup',
  PageDown: 'pagedown',
  CapsLock: 'capslock',
} as const;
